import styled from 'styled-components';

export const Container = styled.div`
  @media (min-width: 996px) {
    width: 100%;
    max-width: 445px;
  }
`;
